module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"start":"Старт","design":"Дизайн","blog":"Блог","settings":"Настройки","careerPortal":"Портал"}}')
  delete Component.options._Ctor
}
